import IconButton from '@mui/material/IconButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CardFiles from '../../../../../components/CockpitCards/CardFiles';


export default function Vcf(data) {


return (
<>
<CardFiles


headline = "vcf" 
subtext = "Here you can download the vcf file. This file contains all the identified variants versus the reference genome."

    content_1 = {<>                         
            Sample: <br />
            Date: <br />
            Sequencer: <br />
            File Size: <br />
            Description: 
         </>} 

content_2 = {<>                

            {data.data[0]} <br />
            {data.data[1]} <br />
            {data.data[2]} <br />
            ~ 7 GB <br />
            Variants <br />HREF_HG38 <br />
            </>} 

action = {
        <IconButton href = {data.data[3]} sx={{ color: 'success.light' }} >
            <CloudDownloadIcon sx={{fontSize: '2.5rem',}} /> 
        </IconButton> 
}
  
    
/>    
</>

)};
